import Cookies from "universal-cookie";
import { postData } from "@/utils/requests";
import { burl } from "@/config/site";
import { AffiliateId } from "@/components/login/loginStore";

const cookies = new Cookies();

export const addPageView = () => {
    const affiliate_id = AffiliateId.getState().affiliate_id;
    const newEvent = {
        affiliate_id: affiliate_id ? affiliate_id : null,
        event_type: "page_view",
        campaign: cookies.get("utm_campaign") ? cookies.get("utm_campaign") : null,
    };
    const isAffiliateEvent = affiliate_id !== null;
    if (isAffiliateEvent && newEvent.affiliate_id) {
        postData(burl("/api/affiliate_dashboard"), newEvent, () => { }, false);
    }
};
